import { CreateOrderRequest, UpdateOrderRequest } from '../../common/api/clients/order.api';

import { OrderModel } from './OrderModel';

const toCreateOrderRequest = (order: OrderModel): CreateOrderRequest => {
    return {
        agentId: order.agentId || null,
        buyerReference: order.buyerReference || null,
        comment: order.comment,
        portId: order.portId,
        receiverSupplierIds: order.receiverSupplierIds,
        receiverContractIds: order.receiverContractIds,
        samplekits: order.samplekits,
        spot: order.spot,
        state: order.state,
        vesselId: order.vesselId,
        chosenOfferId: order.chosenOfferId || null,
        type: order.type,
        fileIds: order.fileIds || null,
        creationComment: order.creationComment || null,
        scheduleSharingEnabled: order.scheduleSharingEnabled ?? false,
    };
};

export const toUpdateOrderRequest = (order: OrderModel): UpdateOrderRequest => {
    return {
        ...toCreateOrderRequest(order),
        dateDelivery: order.dateDelivery || null,
        items: order.items,
        cancelReason: order.cancelReason || null,
    };
};
